export const groupBy = (set = [], key) => {
  const obj = {};
  if (set.length > 0) {
    set?.forEach((n) => {
      obj[n[key]] = obj[n[key]] || [];
      obj[n[key]].push(n);
    });
  }
  return obj;
};
